import { __module as t } from "../../../_virtual/isISIN.js";
import { a as e } from "./util/assertString.js";
Object.defineProperty(r = t.exports, "__esModule", {
  value: !0
}), r.default = function (t) {
  if ((0, a.default)(t), !o.test(t)) return !1;
  for (var e = !0, r = 0, s = t.length - 2; s >= 0; s--) if (t[s] >= "A" && t[s] <= "Z") for (var u = t[s].charCodeAt(0) - 55, l = u % 10, f = Math.trunc(u / 10), d = 0, i = [l, f]; d < i.length; d++) {
    var n = i[d];
    e ? n >= 5 ? r += 1 + (n - 5) * 2 : r += 2 * n : r += n, e = !e;
  } else {
    var p = t[s].charCodeAt(0) - 48;
    e ? p >= 5 ? r += 1 + (p - 5) * 2 : r += 2 * p : r += p, e = !e;
  }
  var v = 10 * Math.trunc((r + 9) / 10) - r;
  return +t[t.length - 1] === v;
}, a = e && e.__esModule ? e : {
  default: e
}, o = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/, t.exports = r.default, t.exports.default = r.default;
var r,
  a,
  o,
  s = t.exports;
export { s as i };